export default __webpack_public_path__ + "static/media/light-on.2feded75.svg";